import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from './shared/ui/toaster.component';
import { LanguageStore } from './core/services/language.store';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToasterComponent],
  template: `
    <router-outlet />
    <app-toaster />
  `,
})
export class App {
  private readonly _lang = inject(LanguageStore);
}
